import { Link as RouterLink, useNavigate } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Stack } from "@mui/material";
// components
import Page from "../components/Page";
//
import { MaintenanceIllustration } from "../assets";
import Image from "src/components/Image";
import TextMaxLine from "src/components/TextMaxLine";
import { m } from "framer-motion";
import { varFade } from "src/components/animate";
import { useEffect } from "react";
import Logo from "src/components/Logo";

// ----------------------------------------------------------------------

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 520,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function MaintenanceUnplanned({ sx }) {
  const navigate = useNavigate();
  useEffect(() => {
    let mode = localStorage.getItem("mode");
    if (mode == "maintain") {
    } else {
      navigate("/");
    }
  }, []);

  return (
    <Page title="Maintenance">
      <Container>
        <ContentStyle sx={{ textAlign: "center", alignItems: "center" }}>
          <m.div {...varFade().inDown}>
            <Stack sx={{ mb: 3 }}>
              {/* <Image
                sx={{
                  maxWidth: sx?.width || 120,
                  maxHeight: sx?.height || 120,
                  objectFit: "contain",
                }}
                src={window.globalTS?.logo}
              /> */}
              <Logo
                sx={{
                  width: 120,
                  height: 120,
                  objectFit: "contain",
                }}
              />
            </Stack>
          </m.div>

          <m.div {...varFade().inUp}>
            <Image src="/assets/maintenance.png" sx={{ width: "100%" }} />
            <Stack sx={{ my: 2 }}>
              <Typography variant="h4" paragraph>
                We're down for maintenance
              </Typography>

              <TextMaxLine variant="subtitle1" sx={{ color: "text.secondary" }}>
                Be right back shortly
              </TextMaxLine>
            </Stack>
          </m.div>
        </ContentStyle>
      </Container>
    </Page>
  );
}
